 export default {
  getCategoryById: (state) => (id) => {
    return state.category.find(category => category.id === id)
  }
}